import styled from "styled-components";
import { Skeleton, ProgressCircle } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import RegisterElement from "./register-element";
import { DialogRoot } from "../../../components/ui/dialog";
import RegisterDetailsDialog from "./register-details-dialog";
import { responsive } from "../../../media-quries";
import { Helmet } from "react-helmet";

const Container = styled.div`
  padding-bottom: 24px;
  margin: 40px 0;

  ${responsive.sm`
    margin-top: 160px;
  `}
`;
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const LoadingHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0;
`;
const LoadingText = styled.span`
  font-size: 20px;
`;
const RegistersListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

function Loading() {
    useEffect(() => {
        setTimeout(() => {
            window.scrollBy({ top: 300, behavior: "smooth" });
        }, 100);
    }, []);

    return (
        <LoadingContainer>
            <LoadingHeader>
                <LoadingText>Cierpliwości, wyszukuję księgi wieczyste</LoadingText>
                <ProgressCircle.Root value={null} size="sm">
                    <ProgressCircle.Circle css={{ "--thickness": "2px" }}>
                        <ProgressCircle.Track />
                        <ProgressCircle.Range />
                    </ProgressCircle.Circle>
                </ProgressCircle.Root>
            </LoadingHeader>
            <Skeleton height={50} />
            <Skeleton height={50} />
            <Skeleton height={50} />
            <Skeleton height={50} />
        </LoadingContainer>
    );
}

const NoRegistersContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

function RegistersList({ searching, registersList }) {
    const registerDetailsState = useState({
        type: null,
        data: null,
    });
    const [registerDetails, setRegisterDetails] = registerDetailsState;

    return (
        <Container>
            <Helmet>
                <title>Wyniki wyszukiwania ksiąg wieczystych</title>
                <meta
                    name="description"
                    content="Sprawdź wyniki wyszukiwania ksiąg wieczystych według wybranych kryteriów. Szybko znajdź informacje o stanie prawnym nieruchomości."
                />
                <meta
                    name="keywords"
                    content="księgi wieczyste, wyszukiwanie ksiąg wieczystych, wyniki wyszukiwania, nieruchomości"
                />
            </Helmet>
            <DialogRoot
                motionPreset="slide-in-bottom"
                onExitComplete={() =>
                    setRegisterDetails({
                        type: null,
                        data: null,
                    })
                }
            >
                {searching && <Loading />}
                {registersList && (
                    <RegistersListContainer>
                        {registersList.map((register) => (
                            <RegisterElement
                                key={register.id}
                                register={register}
                                registerDetailsState={registerDetailsState}
                            />
                        ))}
                        {registersList.length === 0 && (
                            <NoRegistersContainer>
                                <h3>Brak ksiąg dla wybranych kryteriów</h3>
                            </NoRegistersContainer>
                        )}
                    </RegistersListContainer>
                )}
                <RegisterDetailsDialog registerDetails={registerDetails} />
            </DialogRoot>
        </Container>
    );
}

export default RegistersList;
